export default function ArgusMark({ className = '', title = 'ARGUS', variant = 'primary' }) {
  const decorative = !title
  const performance = variant === 'performance'

  return (
    <svg
      viewBox="0 0 64 64"
      role={decorative ? undefined : 'img'}
      aria-label={decorative ? undefined : title}
      aria-hidden={decorative ? true : undefined}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {!decorative && <title>{title}</title>}

      {performance ? (
        <>
          <path
            d="M32 3.5 60.5 58H47.2L32 27.3 16.6 58H3.5L32 3.5Zm0 17.4-9.2 19.3h18.4L32 20.9Z"
            fill="currentColor"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M5.5 53.5 53.8 30.2 43.2 41l16.2-5.3-39.8 22.8H7.8l14.7-9.8-17 4.8Z"
            fill="currentColor"
          />
        </>
      ) : (
        <>
          <path
            d="M32 4 60 58H47.2L32 27.4 16.8 58H4L32 4Zm0 17.2-9.1 19.1h18.2L32 21.2Z"
            fill="currentColor"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M8.2 53.8c11.6-7.6 23.7-13.1 43.4-17.9-12.4 5.9-21.4 11.1-29.7 17.7-3.3 2.6-6.1 4-10.1 4H4.7l3.5-3.8Z"
            fill="currentColor"
          />
        </>
      )}
    </svg>
  )
}
